import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  AnexarComprovanteFormData,
  CancelarFaturaFormData,
  EnviarSegundaViaFormData,
  Fatura,
  GerarFaturaDeApuracaoFormData,
  GerarFaturaManualFormData,
  GerarFaturasLoteFormData,
  ReemitirFaturaFormData,
} from '../types';
import { faturasService, type EligibleTenantDto } from './services';

export const fetchEligibleTenants = createAsyncThunk<EligibleTenantDto[]>(
  'faturas/fetchEligibleTenants',
  async (_, { rejectWithValue }) => {
    try {
      return await faturasService.fetchEligibleTenants();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchFaturas = createAsyncThunk<Fatura[]>(
  'faturas/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      return await faturasService.fetchAll();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchFaturaById = createAsyncThunk<Fatura, string>(
  'faturas/fetchById',
  async (faturaId, { rejectWithValue }) => {
    try {
      return await faturasService.fetchById(faturaId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const gerarFaturaManual = createAsyncThunk<Fatura, GerarFaturaManualFormData>(
  'faturas/gerarManual',
  async (data, { rejectWithValue }) => {
    try {
      return await faturasService.gerarFaturaManual(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const gerarFaturaDeApuracao = createAsyncThunk<Fatura, GerarFaturaDeApuracaoFormData>(
  'faturas/gerarDeApuracao',
  async (data, { rejectWithValue }) => {
    try {
      return await faturasService.gerarFaturaDeApuracao(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const gerarFaturasLote = createAsyncThunk<
  { sucesso: Fatura[]; falhas: Array<{ apuracaoId: string; motivo: string }> },
  GerarFaturasLoteFormData
>('faturas/gerarLote', async (data, { rejectWithValue }) => {
  try {
    return await faturasService.gerarFaturasLote(data);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const cancelarFatura = createAsyncThunk<Fatura, CancelarFaturaFormData>(
  'faturas/cancelar',
  async (data, { rejectWithValue }) => {
    try {
      return await faturasService.cancelarFatura(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const reemitirFatura = createAsyncThunk<
  { original: Fatura; nova: Fatura },
  ReemitirFaturaFormData
>('faturas/reemitir', async (data, { rejectWithValue }) => {
  try {
    return await faturasService.reemitirFatura(data);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const enviarSegundaVia = createAsyncThunk<Fatura, EnviarSegundaViaFormData>(
  'faturas/enviarSegundaVia',
  async (data, { rejectWithValue }) => {
    try {
      return await faturasService.enviarSegundaVia(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const anexarComprovante = createAsyncThunk<Fatura, AnexarComprovanteFormData>(
  'faturas/anexarComprovante',
  async (data, { rejectWithValue }) => {
    try {
      return await faturasService.anexarComprovante(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const tentarReemissaoAsaas = createAsyncThunk<Fatura, string>(
  'faturas/tentarReemissaoAsaas',
  async (faturaId, { rejectWithValue }) => {
    try {
      return await faturasService.tentarReemissaoAsaas(faturaId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
